import { render, staticRenderFns } from "./MultiplicationAndDivision.vue?vue&type=template&id=13c01732&lang=pug&"
import script from "./MultiplicationAndDivision.vue?vue&type=script&lang=js&"
export * from "./MultiplicationAndDivision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports